import { useEffect } from 'react'

import { getRequestEmailThreads } from '../../../../api'
import { EMPTY_LIST } from '../../../../constants/common'
import { FILE_SCOPE_REQUEST } from '../../../../constants/file'
import { PAGINATION_ALL_ITEMS_SIZE } from '../../../../constants/pagination'
import { EmailAttachedThreadsModal } from '../../../Email'
import {
  getAllEmailThreadsFromResponse,
  getEmailThreadsFromResponse,
} from '../../Task.utils'
import {
  TASK_FORM_EMAILS_THREADS_FIELD_NAME,
  TASK_FORM_ID_FIELD_NAME,
  TASK_FORM_SERVICE_REQUEST_FIELD_NAME,
} from '../../TaskForm'

export function useTaskAttachEmailThreads({
  emails = EMPTY_LIST,
  isEditing,
  setEmails,
  setModal,
  values,
  onSetInitialValues,
}) {
  function getAttachedEmailThreads(requestId, activityId) {
    getRequestEmailThreads(requestId, {
      activity: activityId,
      page_size: PAGINATION_ALL_ITEMS_SIZE,
    }).then(({ data }) => {
      const initialEmails = data.results.objects

      setEmails(initialEmails)

      onSetInitialValues(curInitialValues => ({
        ...curInitialValues,
        [TASK_FORM_EMAILS_THREADS_FIELD_NAME]: initialEmails,
      }))
    })
  }

  useEffect(() => {
    if (isEditing) {
      getAttachedEmailThreads(
        values[TASK_FORM_SERVICE_REQUEST_FIELD_NAME]?.value,
        values[TASK_FORM_ID_FIELD_NAME]
      )
    }
  }, [isEditing])

  function handleAttach(selectedItems) {
    setEmails(selectedItems)
    setModal(null)
  }

  function handleDeleteEmail(id) {
    setEmails(prev => prev.filter(item => item.uuid !== id))
  }

  function handleClose() {
    setModal(null)
  }

  function getHandleLoadAllEmailThreads(requestId) {
    return () =>
      getRequestEmailThreads(requestId, {
        page_size: PAGINATION_ALL_ITEMS_SIZE,
      })
  }

  function handleOpenEmailThreadsModal() {
    const requestId = values[TASK_FORM_SERVICE_REQUEST_FIELD_NAME]?.value

    setModal(
      <EmailAttachedThreadsModal
        attachedFilesProps={{ scope: FILE_SCOPE_REQUEST, subject: requestId }}
        entityId={requestId}
        getAllItemsFromResponse={getAllEmailThreadsFromResponse}
        getItemsFromResponse={getEmailThreadsFromResponse}
        initialSelection={emails}
        loadAllItems={getHandleLoadAllEmailThreads(requestId)}
        loadItems={getRequestEmailThreads}
        onAttachToForm={handleAttach}
        onClose={handleClose}
      />
    )
  }

  return { handleDeleteEmail, handleOpenEmailThreadsModal }
}
